import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { AppContext } from '../../Context/AppContext';
import Location from '../../Components/Location';
import { convertFishToCard } from '../../Components/CardList';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      experiment: PropTypes.string,
    }),
  }).isRequired,
};

const defaultProps = {
};

function RouteLocation({ match: { params: { locationId } } }) {
  return (
    <AppContext.Consumer>
      {(context) => {
        if (!context) {
          return null;
        }

        const { locations, fish } = context;

        if (!locations) {
          return null;
        }

        const currentLocation = locations.find(i => i.route === locationId);

        if (!currentLocation) {
          return null;
        }

        const commonFish = fish.filter(f => currentLocation.commonFish.indexOf(f.route) !== -1)
          .map(convertFishToCard);
        const possibleFish = fish.filter(f => currentLocation.possibleFish.indexOf(f.route) !== -1)
          .map(convertFishToCard);
        const seasonalFish = fish.filter(f => currentLocation.seasonalFish.indexOf(f.route) !== -1)
          .map(convertFishToCard);

        return (
          <React.Fragment>
            <Helmet>
              <title>
                {`Fish Toronto | ${currentLocation.name}`}
              </title>
            </Helmet>
            <Location
              {...currentLocation}
              commonFish={commonFish}
              possibleFish={possibleFish}
              seasonalFish={seasonalFish}
            />
          </React.Fragment>
        );
      }}
    </AppContext.Consumer>
  );
}

RouteLocation.propTypes = propTypes;
RouteLocation.defaultProps = defaultProps;

export default RouteLocation;



// WEBPACK FOOTER //
// ./src/Routes/RouteLocation/index.jsx